import cn from 'classnames';
import { Heading, Section, Wrapper } from 'components/base';
import CaseIndexItem from 'components/CaseIndexItem';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Carousel from 'react-slick';
import Arrow from 'svgs/events/sme/arrow-right.svg';
import { arrow, arrowIcon, item, prevArrow } from './Customers.module.scss';

const NextArrow = ({ className, onClick }) => (
  <div className={cn(arrow, className)} onClick={onClick}>
    <Arrow className={arrowIcon} />
  </div>
);
NextArrow.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
}

const PrevArrow = ({ className, onClick }) => (
  <div className={cn(arrow, prevArrow, className)} onClick={onClick}>
    <Arrow className={cn(arrowIcon)} />
  </div>
);
PrevArrow.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
}

class CustomersCarousel extends Component {
  render() {
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      arrows: true,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
      responsive: [
        {
          breakpoint: 850,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };
    const { data, customers } = this.props;
    return (
      <Section id="cases">
        <Wrapper size="SL">
          <Heading Tag="h1" size="L" marginBottom="Xs" bold center>
            {customers.heading}
          </Heading>
          <Heading Tag="h2" size="SM" marginBottom="S" center>
            {customers.subheading}
          </Heading>
        </Wrapper>
        <Wrapper size="ML" className="mb-m">
          <Carousel {...settings} className="sme-carousel">
            {data.map((props, i) => (
              <div className={item} key={i}><CaseIndexItem {...props} /></div>
            ))}
          </Carousel>
        </Wrapper>
      </Section>
    );
  }
}

CustomersCarousel.propTypes = {
  data: PropTypes.array.isRequired,
  customers: PropTypes.object.isRequired,
};

export default CustomersCarousel;
